/**
 * @fileoverview As etapas da esteira de cadastro (Empresa, conta, IA, WhatsApp,
 * equipe), em sequência: a feita com o check, a atual em destaque. No celular
 * e na coluna estreita da tela de entrada (compact), só a atual leva o nome na
 * tela (o leitor de tela lê todos). Também o ⓘ da esteira, com a regra numa dica.
 */

import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { Check, Info } from "lucide-react";

import { i18n } from "../../translate/i18n";
import useSetupStyles from "./styles";

export const SETUP_FLOW = ["company", "account", "ai", "whatsapp", "team"];

const SetupProgress = ({ current, compact = false }) => {
  const classes = useSetupStyles();
  // No fim (done), todas ficam feitas.
  const index = SETUP_FLOW.includes(current) ? SETUP_FLOW.indexOf(current) : SETUP_FLOW.length;
  return (
    <ol className={`${classes.progress}${compact ? ` ${classes.progressCompact}` : ""}`} aria-label={i18n.t("companySetup.progressLabel")}>
      {SETUP_FLOW.map((step, position) => {
        const done = position < index;
        const isCurrent = position === index;
        return (
          <li
            key={step}
            className={`${classes.progressItem}${done ? ` ${classes.progressDone}` : ""}${isCurrent ? ` ${classes.progressCurrent}` : ""}`}
            aria-current={isCurrent ? "step" : undefined}
          >
            <span className={classes.progressMark} aria-hidden="true">
              {done ? <Check size={11} strokeWidth={3} /> : position + 1}
            </span>
            <span className={classes.progressLabel}>{i18n.t(`companySetup.steps.${step}`)}</span>
          </li>
        );
      })}
    </ol>
  );
};

/** A regra que não cabe na tela: num ⓘ, com a dica ao passar o mouse, ao focar ou ao tocar. */
export const SetupInfo = ({ text, label }) => {
  const classes = useSetupStyles();
  return (
    <Tooltip title={text} placement="top" enterTouchDelay={0} leaveTouchDelay={8000} classes={{ tooltip: classes.tooltip }}>
      <button type="button" className={classes.info} aria-label={label || text}>
        <Info />
      </button>
    </Tooltip>
  );
};

export default SetupProgress;
